import React from 'react';

// Dot + label badge aligned with the Intellio design system.
// No purple, indigo, or violet — see architecture red lines.
export type StatusBadgeVariant = 'success' | 'warning' | 'error' | 'info' | 'neutral';

interface StatusBadgeProps {
  variant: StatusBadgeVariant;
  label: string;
  className?: string;
}

const VARIANT_STYLES: Record<
  StatusBadgeVariant,
  { dot: string; text: string; bg: string }
> = {
  success: {
    dot: 'bg-aquamarine',
    text: 'text-jungle',
    bg: 'bg-success-background',
  },
  warning: {
    dot: 'bg-coral',
    text: 'text-irongrey',
    bg: 'bg-warning-background',
  },
  error: {
    dot: 'bg-strawberry',
    text: 'text-strawberry',
    bg: 'bg-error-background',
  },
  info: {
    dot: 'bg-primary',
    text: 'text-primary',
    bg: 'bg-info-background',
  },
  neutral: {
    dot: 'bg-text-tertiary',
    text: 'text-text-secondary',
    bg: 'bg-muted',
  },
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  variant,
  label,
  className = '',
}) => {
  const { dot, text, bg } = VARIANT_STYLES[variant];
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${bg} ${text} ${className}`}
    >
      <span
        className={`w-1.5 h-1.5 rounded-full shrink-0 ${dot}`}
        aria-hidden="true"
      />
      {label}
    </span>
  );
};
